(function () {
  function init() {
    const originalBuyNow = document.querySelector(
      '.shopify-payment-button__button'
    );

    if (!originalBuyNow) return;

    const stickyButton = [...document.querySelectorAll('button')]
      .find(btn =>
        btn.textContent.trim().toLowerCase() === 'add to cart' &&
        btn.closest('.m-sticky-atc, .m-product-sticky-atc, [class*="sticky"]')
      );

    if (!stickyButton) return;

    const originalText = stickyButton.textContent;

    const observer = new IntersectionObserver(entries => {
      const visible = entries[0].isIntersecting;

      stickyButton.textContent = visible
        ? originalText
        : 'Buy Now';

      stickyButton.dataset.snBuyNow = visible ? '0' : '1';
    }, { threshold: 0 });

    observer.observe(originalBuyNow);

    stickyButton.addEventListener('click', function (event) {
      if (stickyButton.dataset.snBuyNow !== '1') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      originalBuyNow.click();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();